const React = require('react');

const Carousel = require('./misc/Carousel');
const dataHelper = require('../dataHelper');

async function fetchFrontpage() {
  try {
    const res = await dataHelper.fetchData('frontpage.json');
    const data = await res.json();
    return data;
  }
  catch(e) {
    console.log('error', e)
  }
  return null
}

const FrontPage = () => {
  const [frontpage, setFrontpage] = React.useState(null);
  const [isFetching, setIsFetching] = React.useState(false);

  React.useEffect(() => {
    setIsFetching(true);
    fetchFrontpage().then(setFrontpage).finally(() => setIsFetching(false));
  }, []);

  const usecases = frontpage ? frontpage.carousel : [];
  if (isFetching) {
    return <main className="front-page">Fetching data...</main>;
  }
  if (!frontpage || !usecases?.length) {
    return <main className="front-page">Failed to load front page. Refresh?</main>;
  }

  const current = Math.floor(Math.random() * usecases.length);
  return (
    <main className="front-page">
      <Carousel items={usecases} current={current} />
      <footer>Build web applications, macros and integrations for the world's most open and flexible platform for video collaboration devices.</footer>
    </main>
  );
};

module.exports = FrontPage;
